import React from 'react';
import { PlaylistModule, DarkMembersSettings } from '@/store/playlist/types';
import { cn } from '@/lib/utils';

interface ModuleCardProps {
  module: PlaylistModule;
  onClick: () => void;
  settings?: DarkMembersSettings;
}

export function ModuleCard({ module, onClick, settings }: ModuleCardProps) {
  const borderRadius = settings?.cardBorderRadius ?? 16;
  const hasShadow = settings?.cardShadow ?? true;
  const hasOverlay = settings?.cardOverlay ?? true;
  const textColor = settings?.cardTextColor === 'gray' ? '#9CA3AF' : '#FFFFFF';
  const titlePosition = settings?.cardTitlePosition || 'inside';
  const hasBorder = settings?.cardBorder ?? true;
  const borderColor = settings?.cardBorderColor || 'rgba(232, 160, 191, 0.4)';

  return (
    <div 
      onClick={onClick}
      className="cursor-pointer group relative"
    >
      {/* Imagem 600×1050 (aspect 9:16) */}
      <div 
        className={cn(
          "aspect-[9/16] overflow-hidden transition-all duration-300 relative",
          "group-hover:scale-[1.02] bg-gradient-to-br from-[#1A1A1A] to-[#252525]",
          hasShadow && "shadow-[0_8px_24px_rgba(0,0,0,0.35)]"
        )}
        style={{
          backgroundImage: module.thumbnailUrl ? `url(${module.thumbnailUrl})` : 'none',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          borderRadius: `${borderRadius}px`,
          border: hasBorder ? `1px solid ${borderColor}` : 'none',
        }}
      >
        {!module.thumbnailUrl && (
          <div className="w-full h-full flex items-center justify-center">
            <span className="text-white/40 text-4xl">📚</span>
          </div>
        )}
        
        {/* Sombra Gradiente Premium - Mais intensa quando título está dentro */}
        <div 
          className={cn(
            "absolute bottom-0 left-0 right-0 pointer-events-none",
            titlePosition === 'inside' ? "h-1/2" : "h-1/3"
          )}
          style={{
            background: titlePosition === 'inside' 
              ? 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.5) 40%, rgba(0,0,0,0.2) 70%, transparent 100%)'
              : 'linear-gradient(to top, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.3) 50%, transparent 100%)',
            borderRadius: `0 0 ${borderRadius}px ${borderRadius}px`,
          }}
        />
        
        {/* Overlay Gradient Interno com Título (opção 'inside') */}
        {titlePosition === 'inside' && hasOverlay && (
          <div 
            className="absolute bottom-0 left-0 right-0 p-3"
            style={{
              background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)',
              borderRadius: `0 0 ${borderRadius}px ${borderRadius}px`,
            }}
          >
            <h3 
              className="font-semibold text-[18px] leading-tight"
              style={{ color: textColor }}
            >
              {module.title}
            </h3>
          </div>
        )}
      </div>
      
      {/* Título ABAIXO do card (opção 'below') */}
      {titlePosition === 'below' && (
        <h3 className="mt-3 text-white text-sm font-medium">
          {module.title}
        </h3>
      )}
    </div>
  );
}
